'use client'

import { useState } from 'react'
import ExpressCheckout from '@/app/_components/ExpressCheckout'

const ExpressCheckoutWrapper = ({
    expressCheckoutData,
    displayExpressPaymentIcons = true,
    displayStandardPaymentIcons = true,
    usePanel = true,
    headingLevel = 'label',
    headingClassName = '',
    className = ""
}) => {
    const [orderInfo, setOrderInfo] = useState({})

    return (
        <ExpressCheckout
            expressCheckoutData={expressCheckoutData}
            setOrderInfo={setOrderInfo}
            displayExpressPaymentIcons={displayExpressPaymentIcons}
            displayStandardPaymentIcons={displayStandardPaymentIcons}
            usePanel={usePanel}
            headingLevel={headingLevel}
            headingClassName={headingClassName}
            className={className}
        />
    )
}

export default ExpressCheckoutWrapper
